import request from '@/utils/request'

/**
 * 获取店铺套餐分佣配置
 * @param {Object} params - 查询参数
 * @param {Number} params.agent_id - 店铺ID（必填，后端字段名是agent_id，值是shop_id）
 * @returns 返回店铺所有套餐的分佣配置，包含：
 *   - 套餐信息（名称、价格、默认分佣）
 *   - 特殊分佣配置（类型、值）
 *   - 销售统计（销售数量、销售金额、总佣金）
 */
export function getAgentPackages(params) {
  return request({
    url: '/fuyou/iccid/recharge/admin/commission/agent-packages',
    method: 'post',
    data: {
      agent_id: params.agent_id
    }
  })
}

/**
 * 更新分佣配置
 * @param {Object} data - 分佣配置数据
 * @param {Number} data.agent_id - 店铺ID（必填，后端字段名是agent_id，值是shop_id）
 * @param {String} data.package_code - 套餐编码（必填）
 * @param {Number} data.commission_type - 分佣类型（1=百分比，2=固定金额）
 * @param {Number} data.commission_value - 分佣值
 * @param {String} data.adjust_reason - 调整原因（选填）
 * @description 如果该店铺没有该套餐的特殊配置，则创建；如果已有配置，则更新
 */
export function updateCommission(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/commission/update',
    method: 'post',
    data: {
      agent_id: data.agent_id,
      package_code: data.package_code,
      commission_type: data.commission_type,
      commission_value: data.commission_value,
      adjust_reason: data.adjust_reason || ''
    }
  })
}

/**
 * 清除特殊分佣配置（恢复默认分佣）
 * @param {Object} data - 参数
 * @param {Number} data.agent_id - 店铺ID（必填，后端字段名是agent_id，值是shop_id）
 * @param {String} data.package_code - 套餐编码（必填）
 * @param {String} data.adjust_reason - 调整原因（选填）
 */
export function clearCommission(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/commission/clear',
    method: 'post',
    data: {
      agent_id: data.agent_id,
      package_code: data.package_code,
      adjust_reason: data.adjust_reason || ''
    }
  })
}

/**
 * 获取分佣调整记录
 * @param {Object} params - 查询参数
 * @param {Number} params.agent_id - 店铺ID（必填，后端字段名是agent_id，值是shop_id）
 * @param {String} params.package_code - 套餐编码（可选，不传则查询该店铺所有套餐的记录）
 * @param {Number} params.page - 页码
 * @param {Number} params.page_size - 每页条数
 * @returns 返回分佣调整历史记录，包含：
 *   - 调整时间、操作人、调整类型（创建/更新）
 *   - 调整前后的分佣配置
 *   - 调整原因
 */
export function getCommissionLogs(params) {
  return request({
    url: '/fuyou/iccid/recharge/admin/commission/logs',
    method: 'post',
    data: {
      agent_id: params.agent_id,
      package_code: params.package_code || undefined,
      page: params.page || 1,
      page_size: params.page_size || 20
    }
  })
}
